import { render, staticRenderFns } from "./SampleFooter.vue?vue&type=template&id=a26795ae"
import script from "./SampleFooter.vue?vue&type=script&lang=js"
export * from "./SampleFooter.vue?vue&type=script&lang=js"
import style0 from "./SampleFooter.vue?vue&type=style&index=0&id=a26795ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports